import { Routes } from '@angular/router';
import { AppNames } from '@pinnakl/shared/types';
import { VirtualDataRoomRoutes } from '@pinnakl/vdr/domain';

export const DEDICATED_INVESTOR_PORTAL_ROUTES: Routes = [
  {
    path: 'user-settings',
    loadChildren: () =>
      import('@pinnakl/user-settings/shell').then(m => m.USER_SETTINGS_ROUTES(AppNames.DEDICATED_INVESTOR_PORTAL)),
  },
  {
    path: '',
    loadComponent: () =>
      import('@pinnakl/dedicated-investor-portal/feature').then(m => m.DedicatedInvestorPortalAppContainerComponent),
    children: [
      {
        path: '',
        redirectTo: 'dataroom',
        pathMatch: 'full',
      },
      {
        path: 'dataroom',
        children: [
          {
            path: '',
            redirectTo: VirtualDataRoomRoutes.Documents,
            pathMatch: 'full',
          },
          {
            path: VirtualDataRoomRoutes.Documents,
            loadComponent: () =>
              import('@pinnakl/dedicated-investor-portal/feature').then(
                m => m.DedicatedInvestorPortalFolderContentContainerComponent,
              ),
          },
          {
            path: VirtualDataRoomRoutes.DocumentId,
            loadComponent: () =>
              import('@pinnakl/dedicated-investor-portal/feature').then(
                m => m.DedicatedInvestorPortalFolderContentContainerComponent,
              ),
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'dataroom',
        pathMatch: 'full',
      },
    ],
  },
];
